angular
  .module('tasksPm')

  .config([
    '$stateProvider',

    function($stateProvider) {
      const path = 'custom/tasksPm/views/';

      $stateProvider
        .state('root.app.simple.tasksPm', {
          url: '/tasks-pm',
          params: {
            company: null,
            customer: null,
            workflow: null
          },
          views: {
            content: {
              templateUrl: path + 'task-manager.html',
              controller: 'TasksPmCtrl'
            }
          },
          permissions: {
            resources: { tasksPm: ['read'] }
          }
        })
        .state('root.app.simple.taskPmDetail', {
          url: '/tasks-pm/:id',
          views: {
            content: {
              templateUrl: path + 'task-manager.html',
              controller: 'TasksPmCtrl'
            }
          },
          permissions: {
            resources: { tasksPm: ['read'] }
          }
        });
    }
  ]);
